import React, { useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { vrmPortalUrlFromEmbed } from '../../utils/liveBoatUtils';

const Wrap = styled.div`
  position: relative;
  border-radius: ${theme.borderRadius.md};
  overflow: hidden;
  border: 1px solid ${theme.colors.border.secondary};
  background: #f8fafc;
`;

const Loader = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.background.secondary};
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.sm};
  z-index: 1;
`;

const Frame = styled.iframe`
  width: 100%;
  height: ${(p) => p.$height}px;
  border: 0;
  display: block;
  background: #fff;
`;

const Foot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.75rem;
  background: ${theme.colors.background.secondary};
  border-top: 1px solid ${theme.colors.border.secondary};
  font-size: ${theme.fontSizes.xs};
  color: ${theme.colors.text.secondary};
`;

const PortalLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: ${theme.colors.secondary.light};
  text-decoration: none;
  font-weight: ${theme.fontWeights.semibold};

  &:hover {
    text-decoration: underline;
  }
`;

const VrmEmbed = ({ url, title = 'Victron VRM power flow', height = 520 }) => {
  const [loaded, setLoaded] = useState(false);
  const portalUrl = vrmPortalUrlFromEmbed(url);

  return (
    <Wrap>
      {!loaded ? <Loader>Loading Victron flow…</Loader> : null}
      <Frame
        src={url}
        title={title}
        $height={height}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        onLoad={() => setLoaded(true)}
      />
      <Foot>
        <span>Powered by Victron VRM</span>
        {portalUrl ? (
          <PortalLink href={portalUrl} target="_blank" rel="noopener noreferrer">
            Open in VRM
            <ArrowTopRightOnSquareIcon className="w-3.5 h-3.5" />
          </PortalLink>
        ) : null}
      </Foot>
    </Wrap>
  );
};

export default VrmEmbed;
